import { request } from '@/utils/request'

// 获取新闻中心列表
export function getNewsList(data) {
  return request({
    url: 'getWebsiteNewsInfoList',
    method: 'get',
    params: data
  })
}

// 获取新闻中心详情
export function getNewsDetail(data) {
  return request({
    url: 'getWebsiteNewsInfo',
    method: 'get',
    params: data
  })
}

